import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import * as func from "../common/tenvicCommon/FunctionCalls";
import * as funct from "../common/manipurCommon/FunctionCalls";
import * as athfun from "../common/athleteCommon/FunctionCalls";
import { usePermissions } from "./PermissionContext";
import Swal from "sweetalert2";

const Header = () => {
  const routes = all_routes;
  const location = useLocation();
  const navigate = useNavigate();
  const userName = localStorage.getItem('UserName');
  const token = localStorage.getItem('accessToken');

  const [menuList, setMenuList] = useState([]);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const { setPermissionsFromMenu } = usePermissions();

  useEffect(() => {
    if (!token) return;

    const fetchMenus = async () => {
      try {
        const userMenusResponse = await (
          location.pathname.includes("/manipur")
            ? funct.UserMenus()
            : location.pathname.includes("/athlete")
              ? athfun.UserMenus()
              : func.UserMenus()
        );

        if (userMenusResponse) {
          setMenuList(userMenusResponse);                // sets your local menuList
          setPermissionsFromMenu(userMenusResponse);     // sets global permissions context
        }
      } catch (error) {
        console.error("Failed to fetch menus:", error);
      }
    };
    fetchMenus();
  }, [token, location.pathname]);

  const toggleMenu = (state: "open" | "close") => {
    document.documentElement.classList.toggle("menu-opened", state === "open");
  };
  const toggleSubMenu = (index: number) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };


  const customStyle = {
    background: location.pathname.includes(routes.home)
      ? "rgb(255,255,255)" // "rgb(15, 42, 78)"
      : "#ffffff",
  };

  return (
    <header
      className={
        location.pathname.includes(routes.home)
          ? "header header-trans"
          : "header header-sticky"
      }
      style={customStyle}
    >
      <div className="container-fluid">
        <nav className="navbar navbar-expand-lg header-nav">
          <div className="navbar-header">
            <Link id="mobile_btn" to="#" onClick={() => toggleMenu('open')}>
              <span className="bar-icon">
                <span />
                <span />
                <span />
              </span>
            </Link>
            <Link to="#" className="navbar-brand logo">

              {location.pathname.includes(routes.home) ? (
                <ImageWithBasePath
                  src="assets/img/Tenvic/TENVICLogo.png"
                  className="img-fluid"
                  alt="Logo"
                />
              ) : (
                <ImageWithBasePath
                  src="assets/img/Tenvic/TENVICLogo.png"
                  className="img-fluid"
                  alt="Another Image"
                />
              )}
            </Link>
          </div>
          <div className="main-menu-wrapper">
            <div className="menu-header">
              <Link to="#" className="menu-logo">
                {location.pathname.includes(routes.home) ? (
                  <ImageWithBasePath
                    src="assets/img/Tenvic/TENVICLogo.png"
                    className="img-fluid"
                    alt="Logo"
                  />
                ) : (
                  <ImageWithBasePath
                    src="assets/img/Tenvic/TENVICLogo.png"
                    className="img-fluid"
                    alt="Another Image"
                  />
                )}
              </Link>
              <Link id="menu_close" className="menu-close" to="#" onClick={() => toggleMenu('close')}>
                <i className="fas fa-times" />
              </Link>
            </div>
            <ul className="main-nav">
              {menuList.map((menuItem, mainIndex) => {
                // Only show the menu if it has "view" permission
                const menuPermissions = menuItem.permissions?.split(",") || [];
                if (!menuPermissions.includes("view")) return null;

                return (
                  <li
                    key={mainIndex}
                    className={`has-submenu ${activeSubMenu === mainIndex ? "open" : ""}`}
                    data-permissions={menuItem.permissions} // optional, if you want to access permissions in DOM
                  >
                    <Link to="#" onClick={() => toggleSubMenu(mainIndex)}>
                      {menuItem.menu_title}
                      {menuItem.submenus && menuItem.submenus.length > 0 && (
                        <i className="fas fa-chevron-down"></i>
                      )}
                    </Link>

                    {menuItem.submenus && menuItem.submenus.length > 0 && (
                      <ul className={`submenu ${activeSubMenu === mainIndex ? "d-block" : "d-none"}`} style={{ maxHeight: "300px", overflow: "auto" }}>
                        {menuItem.submenus
                          .filter((submenu) => {
                            const subPermissions = submenu.permissions?.split(",") || [];
                            return subPermissions.includes("view"); // show only if view permission exists
                          })
                          .map((submenu, subIndex) => (
                            <li
                              key={submenu.submenuId || subIndex}
                              data-permissions={submenu.permissions} // optional
                            >
                              <Link to={submenu.route} onClick={() => toggleMenu("close")}>
                                {submenu.title}
                              </Link>
                            </li>
                          ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
          <ul className="nav header-navbar-rht">
            <li className="nav-item dropdown">
              <div className="avatar">
                <Link
                  to="#"
                  className="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <ImageWithBasePath src="assets/img/Tenvic/user.png" className="avatar-img rounded-circle" width="45px" />
                  <span className="fw-semibold fs-16">{userName}</span>
                </Link>
                <div className="dropdown-menu dropdown-menu-end">
                  {/* Welcome! */}
                  <Link
                    className="dropdown-item"
                    // to="/profile"
                    to={
                      location.pathname.includes("/manipur")
                        ? routes.manipurProfile
                        : location.pathname.includes("/athlete")
                          ? routes.athleteProfile
                          : routes.tenvicProfile
                    }
                  >
                    <i className="fas fa-user"></i>
                    <span>My Profile</span>
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="#"
                  >
                    <i className="fas fa-chart-pie"></i>
                    <span>Performance</span>
                  </Link>
                  <Link
                    className="dropdown-item"
                    onClick={async (e) => {
                      e.preventDefault(); // prevent immediate navigation
                      try {
                        location.pathname.includes("/manipur")
                          ? funct.logout()
                          : func.logout()
                        // const response = await func.logout();
                        localStorage.clear();

                        // Optionally confirm logout with user or show success message
                        Swal.fire({
                          title: 'Logged Out',
                          icon: 'success',
                          confirmButtonText: 'OK',
                          allowOutsideClick: false
                        }).then(() => {
                          if (location.pathname.includes("/manipur")) {
                            navigate(routes.manipurlogin);
                          } else if (location.pathname.includes("/athlete")) {
                            navigate(routes.athleteLogin);
                          } else {
                            navigate(routes.tenviclogin);
                          }
                        });
                      } catch (error) {
                        Swal.fire({
                          title: 'Logout Failed',
                          text: 'Something went wrong during logout.',
                          icon: 'error',
                          confirmButtonText: 'OK'
                        });
                      }
                    }}
                    to="#"
                  >
                    <i className="fas fa-person-running"></i>
                    <span>Logout</span>
                  </Link>
                </div>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
